import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { isThisIncludeNameConfig } from './IsThisInclude.name';

/** 該当データを判断するENUM */
enum IsThisInclude {
  /** 含める */
  include = '1',
  /** 含めない */
  notInclude = '2',
  /** 該当のみ */
  onlyApplicable = '3',
}

const isThisIncludeMap = new Map([
  ['1', IsThisInclude.include],
  ['2', IsThisInclude.notInclude],
  ['3', IsThisInclude.onlyApplicable],
]);

const rawValueToIsThisInclude = rawValueToEnumWithDefault(isThisIncludeMap, IsThisInclude.include);

const isThisIncludeToDisplay = enumToNameWithDefault(IsThisInclude, isThisIncludeNameConfig);

const isThisIncludeToDisplayWithPrefix = enumToNameWithDefault(IsThisInclude, isThisIncludeNameConfig, true);

export { IsThisInclude, isThisIncludeToDisplay, isThisIncludeToDisplayWithPrefix, rawValueToIsThisInclude };
